module.exports = __webpack_public_path__ + "static/sport/h5footer1.6a65e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/h5footer1.png
// module id = 2baR
// module chunks = 0